import { createAction, props } from '@ngrx/store';
import { SnackBarMessage } from '~models/snackbarmessage';

export const showSnackbar = createAction(
  '[APP] SNACKBAR_OPEN',
  props<{ snackBarMessage: SnackBarMessage }>()
);

export const hideSnackbar = createAction('[APP] SNACKBAR_HIDE');
